/* pg-tile-copy */
(function(){
  if (window.pgTileCopy) return; window.pgTileCopy = 1;

  var FROM = /^buy\s*1$/i;
  var TO = 'Single Item';   /* the generic name; on a Buy 2 Get 1 product the noun takes over below ("Single Orb", not "Single Item", by request 2026-09-11 night) */
  var TILES = '#pgx .pgx-tile, #pgx [class*="pgx-lad"]';

  /* Products running Buy 2 Get 1 Free. */
  var B2G1 = {
    'pokemon-crystal-ball-3d-pikachu-gengar-mewtwo-night-light-lamp-pokeball-3d-glass-pokemon-crystal-ball-statue-kids-birthday-gift': {noun: 'Orb', chip: '+3 FREE LED Bases'},
    'anime-pokemon-3d-lenticular-poster-charizard-squirtle-bulbasaur-come-alive-with-amazing-3d-effects-wall-art-printwithout-frame': {noun: 'Print', chip: '+3 PRINTS'},
    /* 2026-09-14: the power ball sells two capacities at two prices, so its
       tile prices are measured on the balls picked in the tile (byPicks
       below), not on the first variant x units. */
    'legends-power-ball': {noun: 'Power Ball', chip: '3 x 12,000mAh', byPicks: true}
  };

  function handle(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  var HANDLE = handle();
  var PACK = B2G1[HANDLE] || null;

  /* The extra volume tiers, orb only. `paid` is how many of the tile's orbs
     are charged, and the price shown is paid x the LIVE unit price -- the
     first variant's price from #pgx-vdata, which pg-landing prints with Liquid
     and so carries the buyer's own currency (CAD, GBP, EUR, AUD), exactly as
     the Single and Buy 2 tiles above it are priced. It used to be a fixed
     figure in USD cents (17495 = 5 x $34.99): right in dollars, and wrong the
     moment a shopper switched currency, when this one tile kept the USD price
     while the rest of the page converted (2026-09-18). Deriving it also means
     a price change in the admin no longer has to be copied here.
     `units` is how many orbs the tile adds, and how many pickers it draws. The
     struck-through figure is the same measure: compare-at x units, derived at
     render time so it matches the tile above. */
  var EXTRA_ON = HANDLE.indexOf('pokemon-crystal') !== -1;
  /* BUY 4 GET 2 IS GONE, by owner request: it did not make sense on the
     ladder. It tied the 3-pack's badge exactly (2 free of 6 IS 1 free of 3, so
     both floor to SAVE 66%), which left two adjacent rungs claiming the same
     saving and nothing to choose between them but size, and its automatic
     discount has been DEACTIVATED in the admin the whole time. The ladder now
     reads Single, Buy 2 Get 1 Free, Buy 5 Get 3 Free -- 50 / 66 / 68, three
     rungs that each beat the one before it.

     Nothing else needs changing for it: the repeating Buy 2 Get 1 still frees
     floor(n/3) at any quantity, so a shopper who puts six orbs in the cart by
     hand is billed the same $139.96 this tile used to promise. To bring it
     back, restore the entry below and reactivate the discount. */
  var EXTRA = [
    /* 2026-09-10: Get 4, not Get 3. At 5 paid the step from Buy 2 Get 1 (66%)
       to Buy 5 Get 3 (68%) was two points, no reason to climb; a fourth free
       orb makes it 72%. The Shopify discount "PokeOrb - Buy 5 Get 4 Free"
       matches. Everything below (ordinal sentence, badge %, chip) derives from
       these numbers. */
    {tier: '5', units: 9, free: 4, paid: 5, title: 'Buy 5, Get 4 FREE', chip: '+9 FREE LED Bases', best: true}
  ];

  /* THE NOTE FOLLOWS THE TILE. It used to be one fixed sentence -- "Buy 2, get
     your 3rd free" -- printed under Add to Cart whichever rung was selected, so
     picking the 8-pack left a line describing a different offer sitting under
     the button. It is derived from the selected tile now, and rebuilt whenever
     selection changes (see ownSelection). Tier 0 has no offer of its own, so it
     points at the first one instead of saying nothing. */
  function noteFor(tier){
    if (!PACK) return 'Bundle pricing shown. Your <b>best available discount</b> is applied automatically at checkout.';
    var n = PACK.noun.toLowerCase();
    if (tier === '1'){
      return 'Buy 2, get your <b>3rd ' + n + ' free</b>. The free one comes off automatically at checkout.';
    }
    for (var i = 0; i < EXTRA.length; i++){
      if (EXTRA[i].tier === tier){
        var E = EXTRA[i];
        return 'Buy ' + (E.units - E.free) + ', get <b>' + E.free + ' ' + n + 's free</b>'
             + '. The free ones come off automatically at checkout.';
      }
    }
    return 'Add 1 more and your <b>3rd ' + n + ' is free</b>. It comes off automatically at checkout.';
  }

  function money(c){ return '$' + (c / 100).toFixed(2); }

  /* What a tile saves against MSRP x units -- the free orbs AND the per-orb
     markdown counted together, by owner request, so the badge agrees with the
     cart's own "You saved" line, which measures the same way. One helper so
     every rung is measured the same way and none of them can drift.

     FLOOR, not round: it only ever understates, which is the safe direction
     for a claim printed on a price. The 3-pack and 6-pack legitimately tie at
     66 now that both are plain buy-X-get-Y arithmetic. */
  function pctOff(pay, full){
    return full > pay ? Math.floor((full - pay) / full * 100) : 0;
  }

  /* MSRP in cents, falling back to the price itself when a product carries no
     compare-at -- the wall art's badge then measures free prints alone. */
  function capOf(v){
    return (v.cap && v.cap > v.price) ? v.cap : v.price;
  }

  function swapIn(root){
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var hits = [], n;
    while ((n = walker.nextNode())){
      if (FROM.test((n.nodeValue || '').trim())) hits.push(n);
    }
    hits.forEach(function(t){ t.nodeValue = t.nodeValue.replace(/buy\s*1/i, PACK ? 'Single ' + PACK.noun : TO); });
    return hits.length > 0;
  }

  var variants = null;
  function vdata(){
    if (variants) return variants;
    var el = document.getElementById('pgx-vdata');
    if (!el) return null;
    try { variants = JSON.parse(el.textContent); } catch(e){ variants = null; }
    return variants;
  }

  /* ---------------- prices that follow the picks ----------------
     For a PACK flagged byPicks (the power ball: 6,000mAh at one price,
     12,000mAh at another) the tile cannot price itself off vs[0] x units,
     because the cart charges each picked ball at its own price. So the tile
     reads its own pickers: `pay` is what the cart will charge for those
     picks (every ball at its price, minus the cheapest for the free one,
     which is exactly how Shopify's Buy 2 Get 1 allocates), `full` is the
     same balls at MSRP. On a tile with one picker `pay` is simply that
     ball's price. Returns null until every picker is on screen, so a tile
     is never priced for fewer balls than it adds. */
  function picked(tile, want){
    var vs = vdata();
    if (!vs || !vs.length) return null;
    var drops = tile.querySelectorAll('.pgx-lad-picks .pg-drop');
    if (drops.length < want) return null;
    var byId = {};
    vs.forEach(function(v){ byId[String(v.id)] = v; });
    var out = [];
    for (var i = 0; i < drops.length; i++){
      var d = drops[i];
      var v = (typeof d.pgValue === 'function') ? byId[String(d.pgValue())] : null;
      out.push(v || vs[0]);
    }
    return out;
  }
  function pickPrice(tile, want, freeOne){
    var vs = picked(tile, want);
    if (!vs) return null;
    var pay = 0, full = 0, min = Infinity;
    vs.forEach(function(v){ pay += v.price; full += capOf(v); if (v.price < min) min = v.price; });
    if (freeOne && vs.length > 1) pay -= min;
    return {pay: pay, full: full, units: vs.length};
  }

  /* ---------------- picker options ----------------
     #pgx-vdata carries id / size / price / cap and NO images, which is fine
     for pricing and wrong for a picker: pgDrop renders a thumbnail per row, so
     options built from vdata gave the third picker a column of broken-image
     icons and a list wide enough to need a horizontal scrollbar.

     So the options come from the same place pgLadder gets its own -- the
     product JSON, with each variant's featured image and the product's first
     image as the fallback. Fetched once and cached; ladder() runs on an
     interval, so the picker is built on whichever pass the fetch lands by. */
  var VOPTS = null, optsBusy = false;
  function loadOpts(){
    if (VOPTS || optsBusy || !HANDLE) return VOPTS;
    optsBusy = true;
    fetch('/products/' + HANDLE + '.js').then(function(r){ return r.json(); }).then(function(p){
      var fallback = (p.images && p.images[0]) || '';
      VOPTS = (p.variants || []).filter(function(v){ return v.available !== false; })
        .map(function(v){
          return {
            id: v.id,
            t: v.title,
            img: (v.featured_image && v.featured_image.src) || fallback
          };
        });
      optsBusy = false;
    }).catch(function(){ optsBusy = false; });
    return VOPTS;
  }

  function put(el, text){
    if (el && el.textContent !== text) el.textContent = text;
  }

  /* ---------------- the ladder ---------------- */

  function ladder(){
    if (!PACK) return;
    var tiles = document.querySelectorAll('#pgx .pgx-lad');
    if (!tiles.length) return;                 /* pgLadder has not built yet */

    /* 1. the offers that no longer exist */
    tiles.forEach(function(t){
      var tier = t.getAttribute('data-pg-tier');
      if (tier === '2' || tier === '3'){
        /* if the shopper had one of them selected, hand selection back to Buy 1 */
        var wasSel = t.classList.contains('pgx-sel');
        if (t.parentNode) t.parentNode.removeChild(t);
        if (wasSel){
          var first = document.querySelector('#pgx .pgx-lad[data-pg-tier="0"]');
          if (first){ first.classList.add('pgx-sel'); first.setAttribute('aria-checked', 'true'); }
        }
      }
    });

    /* 2. the pack tile */
    var tile = document.querySelector('#pgx .pgx-lad[data-pg-tier="1"]');
    if (!tile) return;
    /* NEVER THE 3-UNIT PRICE ON A 2-PICKER TILE. pgLadder builds this tile
       with two pickers; the third is appended below once the product JSON
       has landed. Retitling and repricing it before then let a tap post two
       orbs at the three-orb price (2026-09-11). The tile is kept off screen
       until it carries its third picker (the one-picker wall art design is
       ready at once, its count rides on data-pg-mul). */
    var picks0 = tile.querySelector('.pgx-lad-picks');
    var drops0 = picks0 ? picks0.querySelectorAll('.pg-drop') : [];
    var ready = drops0.length !== 2;
    tile.classList.toggle('pg-building', !ready);

    var vs = vdata();
    if (!vs || !vs.length) return;
    var unit = vs[0].price;
    var cap = capOf(vs[0]);

    /* THE SINGLE STATES ITS SAVING TOO. pgLadder builds tier 0 with no badge
       at all, and the owner circled the empty corner: with every bundle badge
       now measured against MSRP, the single's own 50% off MSRP is the same
       claim and belongs on the same corner. Injected once; put() keeps the
       repaint silent on every later pass. */
    var single = document.querySelector('#pgx .pgx-lad[data-pg-tier="0"]');
    var one = null;
    if (single){
      /* the single's own price follows the ball picked in it on a byPicks
         pack; on a one-price product it is simply the live unit price, so
         every rung on the ladder -- Single, Buy 2, Buy 5 -- is priced from the
         one presentment-currency figure rather than pgLadder's product JSON */
      one = PACK.byPicks ? pickPrice(single, 1, false) : {pay: unit, full: cap};
      if (one){
        put(single.querySelector('.pgx-lad-px b'), money(one.pay));
        var os = single.querySelector('.pgx-lad-px s');
        if (one.full > one.pay){
          if (!os){ os = document.createElement('s'); var opx = single.querySelector('.pgx-lad-px'); if (opx) opx.appendChild(os); }
          put(os, money(one.full));
        } else if (os && os.parentNode){ os.parentNode.removeChild(os); }
      }
    }
    var sUnit = one ? one.pay : unit, sCap = one ? one.full : cap;
    if (single && sCap > sUnit){
      var sb = single.querySelector('.pgx-lad-badge');
      if (!sb){
        sb = document.createElement('span');
        sb.className = 'pgx-lad-badge';
        single.insertBefore(sb, single.firstChild);
      }
      put(sb, 'SAVE ' + pctOff(sUnit, sCap) + '%');
    }

    if (ready){
    /* what the three picks cost: vs[0] x units on a one-price product, the
       picked balls' own prices on a byPicks one (see pickPrice) */
    var pay2 = unit * 2, full3 = cap * 3;
    if (PACK.byPicks){
      var pp = pickPrice(tile, 3, true);
      if (pp){ pay2 = pp.pay; full3 = pp.full; }
    }
    put(tile.querySelector('.pgx-lad-t b'), 'Buy 2, Get 1 FREE');
    put(tile.querySelector('.pgx-lad-chip:not(.pgx-each)'), PACK.chip);
    eachPill(tile, pay2, 3);
    put(tile.querySelector('.pgx-lad-save'), '3rd ' + PACK.noun + ' = FREE!');
    /* BEST DEAL BELONGS TO THE BIGGEST PACK, so this tile states what it saves
       instead, like every other rung. Same arithmetic the new tiles use: what
       is paid against MSRP for the same number of orbs. The struck figure is
       the same measure, so the badge is the arithmetic between the two prices
       printed beside it. */
    /* MOST POPULAR rides in this pill beside the percent, the way the lamp
       page's Duo Pack and the console's Duo Pack wear it (by request,
       2026-09-11 night: "add most popular for the orbs box for duo"). The
       middle dot is the same one the Best Deal pill uses. */
    put(tile.querySelector('.pgx-lad-badge'), 'MOST POPULAR · SAVE ' + pctOff(pay2, full3) + '%');
    put(tile.querySelector('.pgx-lad-px b'), money(pay2));
    put(tile.querySelector('.pgx-lad-px s'), money(full3));
    }

    /* 3. three units, through pgLadder's own add-to-cart */
    var picks = tile.querySelector('.pgx-lad-picks');
    if (!picks) return;
    var drops = picks.querySelectorAll('.pg-drop');

    if (drops.length > 1){
      /* one picker per unit: add the third, built the way pgLadder builds them */
      if (drops.length >= 3) return;
      if (typeof window.pgDrop !== 'function') return;   /* no factory, no guess */
      var opts = loadOpts();
      if (!opts || !opts.length) return;                 /* still loading: next pass */
      var row = document.createElement('div');
      row.className = 'pgx-lad-row';
      row.appendChild(window.pgDrop(opts, opts[2 % opts.length].id, null));
      picks.appendChild(row);
      tile.dataset.pgMul = '1';
    } else if (drops.length === 1){
      /* Single design (the wall art): pgLadder gives the tile ONE picker and
         carries the count on data-pg-mul, with a x N badge beside it.

         The multiplier moves to 3 -- that is what actually decides how many
         units add-to-cart posts. The badge is REMOVED rather than relabelled:
         it is the only place in the tile that repeats the count, the title and
         the "+3 PRINTS" chip already say it, and while it was drawn by
         pgLadder it kept showing the old x2 next to an offer that gives three.
         One fewer number, and no chance of it disagreeing with the cart. */
      tile.dataset.pgMul = '3';
      var pickRow = picks.querySelector('.pgx-lad-row');
      if (pickRow){
        var xb = pickRow.querySelector('b');
        if (xb && xb.parentNode) xb.parentNode.removeChild(xb);
      }
    }
  }

  /* ---------------- the extra volume tiers ----------------

     Built exactly the way pgLadder builds its own -- same classes, same head /
     price / picks structure, same picker factory -- so they inherit the
     ladder's styling and its add-to-cart without either being told about them.
     Appended after the last ladder tile, which is the Buy 2 Get 1 Free tile
     once ladder() has removed the dead ones, so the order on screen reads
     Single, Buy 2 Get 1, Buy 5 Get 3.

     Everything here is a no-op unless the pack tile is on screen: if pgLadder
     tears the ladder down (it rebuilds whenever no .pgx-lad is left) these
     tiles go with it, because leaving them standing is what would stop it
     rebuilding at all -- its own guard is `if (document.querySelector('.pgx-lad')) return`. */

  function ord(k){
    var t = k % 10, h = k % 100;
    if (t === 1 && h !== 11) return k + 'st';
    if (t === 2 && h !== 12) return k + 'nd';
    if (t === 3 && h !== 13) return k + 'rd';
    return k + 'th';
  }

  /* "5th & 6th Orb = FREE!", "6th, 7th & 8th Orb = FREE!" -- the same sentence
     tier 1 gets from ladder(), widened to name more than one free unit. */
  function freeLine(units, free, noun){
    var parts = [];
    for (var i = units - free + 1; i <= units; i++) parts.push(ord(i));
    var last = parts.pop();
    return (parts.length ? parts.join(', ') + ' & ' : '') + last + ' ' + noun + ' = FREE!';
  }

  /* THE PER-UNIT PRICE, a pill in the theme's purple UNDER THE STRUCK PRICE
     ("$23.33 each" on Buy 2 Get 1, "$19.44 each" on Buy 5 Get 4), on every
     rung that adds more than one unit (by request, 2026-09-13: "add the per
     unit costs so people see the savings, for all our products; match the
     theme and not over clutter"). What is paid over every unit the rung
     adds, free ones included, rounded UP to the cent so units x the figure
     never undercuts the price beside it. In the price column, not beside
     the "+3 FREE LED Bases" chip: two pills in the title column stack on
     phones. The console packs do the same in pg-theme-css's calc(); the
     lamp, with no other chip, carries it in its chip slot (pg-dbz-tiles). */
  function eachPill(tile, pay, units){
    var px = tile.querySelector('.pgx-lad-px'); if (!px || !(units > 1)) return;
    var pill = px.querySelector('.pgx-lad-chip.pgx-each');
    if (!pill){ pill = document.createElement('span'); pill.className = 'pgx-lad-chip pgx-each'; px.appendChild(pill); }
    put(pill, money(Math.ceil(pay / units)) + ' each');
  }
  function extraTile(E, unit, cap, opts){
    /* what the cart charges for this rung, in the buyer's currency: the paid
       units at the live unit price (USD: 5 x 3499 = 17495, the figure that
       used to sit in the table above) */
    var pay = E.paid * unit;
    var full = cap * E.units;
    var pct = pctOff(pay, full);
    /* The biggest pack carries BEST DEAL and its percentage together: the badge
       is the only place a tile can claim to be the best, and dropping the
       number to make room would have left the one rung a shopper is meant to
       land on as the only one not saying what it saves. */
    var badge = E.best ? 'BEST DEAL &middot; SAVE ' + pct + '%' : 'SAVE ' + pct + '%';

    var tile = document.createElement('div');
    tile.className = 'pgx-tile pgx-lad';
    tile.setAttribute('role', 'radio');
    tile.setAttribute('aria-checked', 'false');
    tile.setAttribute('tabindex', '0');
    tile.setAttribute('data-pg-tier', E.tier);
    tile.setAttribute('data-pg-extra', '1');
    tile.dataset.pgMul = '1';

    tile.innerHTML = (pct > 0 ? '<span class="pgx-lad-badge">' + badge + '</span>' : '')
      + '<div class="pgx-lad-head"><span class="pgx-duo-dot"></span>'
      + '<div class="pgx-lad-t"><b>' + E.title + '</b>'
      + '<span class="pgx-lad-chip">' + E.chip + '</span>'
      + '<div class="pgx-lad-save">' + freeLine(E.units, E.free, PACK.noun) + '</div></div>'
      + '<div class="pgx-lad-px"><b>' + money(pay) + '</b><s>' + money(full) + '</s><span class="pgx-lad-chip pgx-each">' + money(Math.ceil(pay / E.units)) + ' each</span></div></div>'
      + '<div class="pgx-lad-picks"><div class="lbl">Choose your Poke Balls</div></div>';

    /* One picker per orb, built with pgLadder's own factory rather than cloned
       -- .pg-drop carries pgValue() as a property on the element, and cloneNode
       copies markup but not properties, so a cloned picker throws the moment
       add-to-cart reads it. */
    var picks = tile.querySelector('.pgx-lad-picks');
    for (var i = 0; i < E.units; i++){
      var row = document.createElement('div');
      row.className = 'pgx-lad-row';
      row.appendChild(window.pgDrop(opts, opts[i % opts.length].id, null));
      picks.appendChild(row);
    }
    return tile;
  }

  function extras(){
    if (!EXTRA_ON || !PACK) return;

    var pack = document.querySelector('#pgx .pgx-lad[data-pg-tier="1"]');
    if (!pack){
      /* no pack tile means no ladder (or one mid-rebuild): ours must not
         outlive it, or pgLadder never rebuilds */
      document.querySelectorAll('#pgx .pgx-lad[data-pg-extra]').forEach(function(t){
        if (t.parentNode) t.parentNode.removeChild(t);
      });
      return;
    }

    if (typeof window.pgDrop !== 'function') return;
    var vs = vdata();
    if (!vs || !vs.length) return;
    var unit = vs[0].price;
    var cap = capOf(vs[0]);
    var opts = loadOpts();
    if (!opts || !opts.length) return;                  /* still loading: next pass */

    EXTRA.forEach(function(E){
      if (document.querySelector('#pgx .pgx-lad[data-pg-tier="' + E.tier + '"]')) return;
      var all = document.querySelectorAll('#pgx .pgx-lad');
      var after = all[all.length - 1];
      if (!after || !after.parentNode) return;
      after.parentNode.insertBefore(extraTile(E, unit, cap, opts), after.nextSibling);
    });
  }

  /* ONE OWNER FOR SELECTION. pgLadder's per-tile handler is closed over the
     array of tiles IT built, so it cannot clear pgx-sel from ours and ours
     could not clear it from its. Add-to-cart reads the first selected tile in
     the document, so two selected tiles silently charge for the wrong one.
     This delegated listener runs after whichever handler fired and leaves
     exactly one .pgx-lad selected, whoever built it. */
  function ownSelection(){
    document.addEventListener('click', function(e){
      if (!e.target || !e.target.closest) return;
      var hit = e.target.closest('#pgx .pgx-lad');
      if (!hit) return;
      document.querySelectorAll('#pgx .pgx-lad').forEach(function(t){
        var on = t === hit;
        t.classList.toggle('pgx-sel', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      note();          /* the sentence under the button belongs to the new tile */
      buybar();        /* and so does the bar's pack dropdown */
    });
  }

  function note(){
    var root = document.getElementById('pgx');
    if (!root) return;
    if (!root.querySelector('.pgx-tile, [class*="pgx-lad"]')) return;
    var atc = root.querySelector('.pgx-atc');
    if (!atc || !atc.parentNode) return;
    var p = root.querySelector('.pgx-deal-note');
    if (!p){
      p = document.createElement('p');
      p.className = 'pgx-deal-note';
      atc.parentNode.insertBefore(p, atc);
    }
    var sel = root.querySelector('.pgx-lad.pgx-sel') || root.querySelector('.pgx-tile.pgx-sel');
    var html = noteFor(sel ? (sel.getAttribute('data-pg-tier') || '') : '');
    /* Compare against what we last WROTE, not against innerHTML read back:
       the parser turns `&mdash;` into a literal em dash, so re-reading never
       equals the source string, every pass would rewrite the node, and the
       MutationObserver below would call pass() again -- forever. The record
       lives on a JS property so keeping it is not itself a DOM mutation. */
    if (p.pgNote !== html){ p.pgNote = html; p.innerHTML = html; }
  }

  /* ---------------- the sticky buy bar's pack picker ----------------

     pg-theme-css builds #pg-sticky as title / price / ADD TO CART. It MIRRORS
     the selected tile's price but offers no way to change that selection, and
     the product page is nine screens tall on a phone: by the time the bar
     appears the ladder is far above it, so the one control still on screen
     silently sells whichever tile was picked -- in practice the single, because
     that is what pgLadder selects by default. The bundles were invisible at
     exactly the point the decision gets made.

     So the bar gets one row above it: a <select> naming every visible tile with
     its price and its saving, and -- for products whose tile carries native
     option selects (the console's Storage) -- a second mirroring that one.
     DESKTOP ONLY: on phones the row is hidden outright (see the media rule
     above) -- the owner found two stacked sticky bands too tall for a 390px
     screen, and the thumbnail + price still say what the button sells.

     IT DRIVES THE PAGE'S OWN CONTROLS, IT DOES NOT REPLACE THEM. Choosing a
     pack CLICKS the tile, so pgLadder's per-tile handler and ownSelection()
     above both run and add-to-cart posts that pack unaided; the option select
     writes to the page's select and fires a bubbling change, which is what
     pgLadder's own duo handler listens for. Nothing about the add path is
     duplicated here, so it cannot drift from it. */

  function esc(t){ return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

  /* pgLadder hides the server-rendered tiles with an inline display:none when
     it builds its own, so ask the layout which tiles are real rather than
     trying to reproduce that rule here. */
  function visibleTiles(){
    var out = [];
    document.querySelectorAll('#pgx .pgx-tile').forEach(function(t){
      if (t.getClientRects().length) out.push(t);
    });
    return out;
  }

  function tileLabel(t){
    var name = t.querySelector('.pgx-lad-t b') || t.querySelector('.pgx-tile-name') ||
               t.querySelector('.pgx-tile-row b') || t.querySelector('b');
    var px = t.querySelector('.pgx-lad-px b') || t.querySelector('.pgx-tile-price');
    var badge = t.querySelector('.pgx-lad-badge');
    var out = name ? name.textContent.replace(/\s+/g, ' ').trim() : 'Option';
    var amt = px ? (px.textContent.match(/\$[0-9][0-9.,]*/) || [])[0] : '';
    /* a ladder price cell holds nothing but the price; once pg-money has
       rewritten its $ as EUR or GBP the dollar match above finds nothing */
    if (!amt && px && px.matches && px.matches('.pgx-lad-px b')) amt = px.textContent.replace(/\s+/g, ' ').trim();
    if (amt) out += ' - ' + amt;
    /* the saving rides along: it is the whole reason to pick a bigger pack,
       and the badge is where every tier already states it */
    if (badge){
      var b = badge.textContent.replace(/\s+/g, ' ').trim();
      if (b) out += ' (' + b + ')';
    }
    return out;
  }

  /* The console carries Storage on a select of its own, built by pgLadder's
     single-tile path and living outside the tile; anything else uses the first
     select inside the tile that is actually selected. The orb's pickers are
     .pg-drop widgets, not selects, so they are never matched here -- eight
     design dropdowns do not belong in a bottom bar anyway. */
  function optSource(){
    var st = document.querySelector('#pgx select.pgx-storage');
    if (st && st.getClientRects().length) return st;
    var sel = document.querySelector('#pgx .pgx-tile.pgx-sel');
    if (!sel) return null;
    var s = sel.querySelector('select');
    return (s && s.getClientRects().length) ? s : null;
  }

  var bbRow = null, bbPack = null, bbOpt = null, bbSig = '';

  function buybar(){
    var bar = document.getElementById('pg-sticky');
    if (!bar) return;                        /* not a product page yet */
    var inRow = bar.querySelector('.pgst-in');
    if (!inRow || !inRow.parentNode) return;

    if (!bbRow || !bbRow.isConnected){
      bbRow = document.createElement('div');
      bbRow.className = 'pgs-pick';
      bbRow.innerHTML =
        '<label class="pgs-f pgs-f-pack"><span>Bundle</span>' +
        '<select class="pgs-pack" aria-label="Choose your bundle"></select></label>' +
        '<label class="pgs-f pgs-f-opt"><span class="pgs-opt-lb">Option</span>' +
        '<select class="pgs-opt" aria-label="Choose an option"></select></label>';
      bbPack = bbRow.querySelector('.pgs-pack');
      bbOpt = bbRow.querySelector('.pgs-opt');
      bbSig = '';

      bbPack.addEventListener('change', function(){
        var t = visibleTiles()[parseInt(bbPack.value, 10)];
        if (t) t.click();                    /* the page's own selection path */
        buybar();
      });
      bbOpt.addEventListener('change', function(){
        var src = optSource();
        if (!src || src.value === bbOpt.value) return;
        src.value = bbOpt.value;
        try { src.dispatchEvent(new Event('change', {bubbles: true})); }
        catch(e){
          var ev = document.createEvent('HTMLEvents');
          ev.initEvent('change', true, false);
          src.dispatchEvent(ev);
        }
      });
      inRow.parentNode.insertBefore(bbRow, inRow);
    }

    /* the thumbnail lives in the price/button row, ahead of the title */
    var thumb = inRow.querySelector('.pgst-thumb');
    if (!thumb){
      thumb = document.createElement('img');
      thumb.className = 'pgst-thumb';
      thumb.alt = '';
      thumb.setAttribute('aria-hidden', 'true');
      inRow.insertBefore(thumb, inRow.firstChild);
    }
    /* follow the shopper's own choice where there is one: the selected tile's
       first design picker carries the character they picked, and that is what
       is going in the bag. Fall back to the gallery photo on screen, then to
       the first strip image, so the bar is never left with a broken frame. */
    var pick = document.querySelector('#pgx .pgx-tile.pgx-sel .pgx-lad-picks .pg-drop img')
            || document.querySelector('#pgx .pgx-thumbs button img')
            || document.querySelector('#pgx img');
    var psrc = pick && pick.getAttribute('src');
    if (psrc && thumb.getAttribute('src') !== psrc) thumb.setAttribute('src', psrc);
    /* shown on whether it HAS a picture, not on whether this tick found one.
       buybar() runs on a timer against a ladder that is rebuilt underneath it,
       so a tick can land in the gap where the selected tile's pickers do not
       exist yet -- keyed off psrc the bar would blink its product image out and
       back on every one of those. The last good frame stays up instead. */
    thumb.style.display = thumb.getAttribute('src') ? '' : 'none';

    /* ---- the packs ---- */
    var tiles = visibleTiles();
    var packF = bbRow.querySelector('.pgs-f-pack');
    if (tiles.length > 1){
      packF.style.display = '';
      var sig = tiles.map(tileLabel).join('|');
      if (sig !== bbSig){
        bbSig = sig;
        bbPack.innerHTML = tiles.map(function(t, i){
          return '<option value="' + i + '">' + esc(tileLabel(t)) + '</option>';
        }).join('');
      }
      var at = 0;
      for (var i = 0; i < tiles.length; i++){
        if (tiles[i].classList.contains('pgx-sel')){ at = i; break; }
      }
      if (bbPack.value !== String(at)) bbPack.value = String(at);
    } else {
      packF.style.display = 'none';          /* one tile: nothing to choose */
      bbSig = '';
    }

    /* ---- the selected pack's own options ---- */
    var src = optSource();
    var optF = bbRow.querySelector('.pgs-f-opt');
    if (!src){
      optF.style.display = 'none';
      bbOpt.pgSig = '';
      return;
    }
    optF.style.display = '';
    var osig = Array.prototype.map.call(src.options, function(o){
      return o.value + ':' + o.textContent;
    }).join('|');
    if (bbOpt.pgSig !== osig){
      bbOpt.pgSig = osig;
      bbOpt.innerHTML = src.innerHTML;
    }
    if (bbOpt.value !== src.value) bbOpt.value = src.value;
    var lb = bbRow.querySelector('.pgs-opt-lb');
    var lbt = src.getAttribute('aria-label') || 'Option';
    if (lb.textContent !== lbt) lb.textContent = lbt;
  }

  /* see the note in the stylesheet above */
  var fitCtx = null;
  function nameNeeds(name){
    /* the text alone, at the size it wears inside the row (17px 700), not the
       chip that may sit inside it */
    var txt = '';
    for (var i = 0; i < name.childNodes.length; i++) if (name.childNodes[i].nodeType === 3) txt += name.childNodes[i].textContent;
    txt = txt.replace(/\s+/g, ' ').trim();
    if (!txt) return 0;
    if (!fitCtx){ var cv = document.createElement('canvas'); fitCtx = cv.getContext && cv.getContext('2d'); }
    if (!fitCtx) return 9999;
    fitCtx.font = '700 17px ' + (getComputedStyle(name).fontFamily || 'sans-serif');
    return fitCtx.measureText(txt).width;
  }
  function nameFit(){
    if (!window.matchMedia || !window.matchMedia('(max-width:600px)').matches) return;
    document.querySelectorAll('#pgx .pgx-tile').forEach(function(t){
      var row = t.querySelector('.pgx-tile-row');
      var name = t.querySelector('.pgx-tile-name');
      if (!row || !name) return;
      /* A NAME THAT FITS BESIDE THE RADIO STAYS THERE (2026-09-11 night: the
         console's first tile is titled "Single R36S" now, and the owner wants
         its dot beside the title like the pack tiles and the lamp page). The
         lift below is only for a title the middle column cannot hold, such as
         the full "Pocket Era R36S - Handheld Console". Measured against that
         column: the row minus the radio, the price and the two gaps. */
      var price = row.querySelector('.pgx-tile-price');
      var avail = row.getBoundingClientRect().width - 34 - (price ? price.getBoundingClientRect().width + 12 : 0);
      if (avail > 60 && nameNeeds(name) <= avail){
        if (name.parentElement === t){
          var mid = null;
          for (var k = 0; k < row.children.length; k++){
            var ch = row.children[k];
            if (ch !== price && !ch.classList.contains('pgx-radio')){ mid = ch; break; }
          }
          if (mid) mid.insertBefore(name, mid.firstChild);
        }
        if (name.classList.contains('pg-name-solo')) name.classList.remove('pg-name-solo');
        return;
      }
      /* pgLadder rebuilds the tile, so this re-runs on every pass and is
         idempotent: the move only happens while the name is still nested. */
      if (name.parentElement !== t) t.insertBefore(name, row);
      if (!name.classList.contains('pg-name-solo')) name.classList.add('pg-name-solo');
    });
  }

  function pass(){
    document.querySelectorAll(TILES).forEach(function(tile){
      if (tile.dataset.pgCopy) return;
      if (swapIn(tile)) tile.dataset.pgCopy = '1';
    });
    ladder();
    extras();
    nameFit();
    note();
    buybar();
  }

  function boot(){
    ownSelection();
    loadOpts();   /* the third picker's options, fetched before pgLadder can build the tile */
    pass();
    var root = document.getElementById('pgx');
    if (root){
      try { new MutationObserver(pass).observe(root, {childList: true, subtree: true}); } catch(e){}
    }
    /* pgLadder rebuilds on its own 3s timer whenever .pgx-lad is missing, so
       this keeps pace with it rather than running once */
    setInterval(pass, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
